export default __webpack_public_path__ + "static/media/Figtree-SemiBold.294e8258.ttf";